<template>
  <div class="all-height d-flex justify-center align-center" data-testid="no-access">
    <div class="text-center d-block" data-testid="no-access__content">
      <h3 class="mb-3 font-weight-medium primary--text" data-testid="no-access__heading">OOPS!</h3>
      <div class="title mb-3" data-testid="no-access__message"><span>404 - Page not found</span></div>
      <v-btn color="primary" href="/" data-testid="no-access__home-button"><v-icon left>mdi-home</v-icon><span>Go to home</span></v-btn>
    </div>
  </div>
</template>

<script>
  export default {
    data: () => ({
    }),
    methods: {
    }
  }
</script>